<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="900"
      max-width="800"
      v-on:click:outside="closeDialog()"
      v-on:keydown.esc="closeDialog()"
    >
      <v-card
        elevation="0"
        style="border-top: 10px solid #095797"
      >
        <v-card-title style="font-size:17px">
          <div v-if="coursGratuitCSSMembre || coursGratuitCSSExterne || estEnAttenteDePaiement || coursGratuit">
            {{ $t("Paiement.annulation.coursGratuitOuAttenteDePaiement") }}
          </div>
          <div v-else-if="estCoursSansRemboursement">
            {{ $t("Paiement.annulation.coursSansRemboursement") }}
          </div>
          <div v-else>
            {{ $t("Paiement.annulation.avertissement") }}
          </div>
        </v-card-title>
        <div>
          <p class="nomCoursDialoguesPageConfirmation">{{ cours.titre }}</p>
        </div>

        <!-- Boutons -->
        <div
          :class="estMobile ? 'ajustementBoutonsDialoguesMobile' : 'mx-10' "
          style="display:flex"
        >
          <v-spacer style="width:50%"></v-spacer>
          <div
            class="text-right mt-5"
            style="padding-right:10px"
            :class="estMobile ? 'd-flex' : ''"
          >
            <v-btn
              outlined
              v-on:click="closeDialog()"
              :disabled="remboursementPartielEnCours"
              class="mb-3 btnRetraitOuAnnulation longueurBoutonPageConfirmation"
            >{{ $t("dialogInscription.btnAnnuler") }}</v-btn>
            <v-btn
              v-on:click="annulerInscription()"
              :loading="remboursementPartielEnCours"
              class="mb-3 ml-4 stylesBtnConfirmation longueurBoutonPageConfirmation"
            >
              {{ $t("Paiement.annulation.continuer") }}
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import useAppStore from '@/store/appStore';
import usePaiementStore from '@/store/paiementStore';
import useInscriptionStore from '@/store/inscriptionStore';
import usePanierStore from '@/store/panierStore';
import { ProvenanceEleve, EtatCoursEleve } from '../../../outils/Enum';

const racineLocalStorage = 'csqc_coursEte_';
const localStoragePanier = 'Panier';

export default {
  name: 'AnnulationInscriptionDialog',
  data() {
    return {
      dialog: false,
      estMobile: false,
      cours: {},
      remboursementPartielEnCours: false,
      provientDeCSSMonteregieEstrie: ProvenanceEleve.CSSMonteregieEstrie,
      provientExterne: ProvenanceEleve.CSSExterne,
      provientEcolePrivee: ProvenanceEleve.EcolePrive,
      coursGratuitCSSMembre: false,
      coursGratuitCSSExterne: false,
      coursGratuitPrive: false,
      coursGratuitScolarise: false,
      estEnAttenteDePaiement: false,
      etatEnAttenteDePaiement: EtatCoursEleve.EnAttentePaiement,
      estCSSMonteregieEstrie: false,
      estCSSExterne: false,
      estEcolePrive: false,
      estScolariseMaison: false,
      estCoursSansRemboursement: false,
      montantFraisAdministration: 50,
      coursGratuit: false,
    };
  },
  setup() {
    const appStore = useAppStore();
    const paiementStore = usePaiementStore();
    const inscriptionStore = useInscriptionStore();
    const panierStore = usePanierStore();

    return {
      appStore, paiementStore, inscriptionStore, panierStore,
    };
  },
  computed: {
    estCoursGratuit() {
      return this.coursGratuitCSSMembre || this.coursGratuitScolarise || this.coursGratuitCSSExterne || this.coursGratuitPrive;
    },
  },
  created() {
    if (window.screen.width <= 760) {
      this.estMobile = true;
    } else {
      this.estMobile = false;
    }
  },
  methods: {
    ouvrirDialog(cours) {
      this.cours = cours; // Affectation du cours choisi dans le dialogue d'annulation

      // Vérifier si l'organisme offre le cours gratuitement
      const provenance = cours.provenanceEleve;
      const { estScolariseMaison } = cours;

      // Vérifier voir si c'est un cours gratuit et sa provenance
      // CSS membre et non scolarise à la maison
      if (provenance === this.provientDeCSSMonteregieEstrie && !estScolariseMaison) {
        this.estCSSMonteregieEstrie = true;

        if (cours.prixCSSMembre === 0) this.coursGratuitCSSMembre = true;
      }

      // Élève provennt d'une CSS membre et est un élève scolarise à la maison
      if (cours.provenanceEleve === this.provientDeCSSMonteregieEstrie && cours.estScolariseMaison) {
        this.estScolariseMaison = true;

        if (cours.prixScolarise === 0) this.coursGratuitScolarise = true;
      }

      // Élève provenant d'une CSS Externe
      if (cours.provenanceEleve === this.provientExterne) {
        this.estCSSExterne = true;
        if (cours.prixExterne === 0) this.coursGratuitCSSExterne = true;
      }

      this.coursGratuit = cours.estGratuit;

      // Élève provenant d'école privé
      if (cours.provenanceEleve === this.provientEcolePrivee) {
        this.estEcolePrive = true;

        if (cours.prixPrive === 0) this.coursGratuitPrive = true;
      }

      if (cours.etatCoursEleveId === this.etatEnAttenteDePaiement) {
        this.estEnAttenteDePaiement = true;
      }

      // Déterminer si c'est un cours moins cher que les frais d'administration, mais plus grand que 0. Si oui, le dialogue d'annulation change
      // CSS Montérégie/Estrie
      if (this.estCSSMonteregieEstrie && cours.prixCSSMembre > 0 && cours.prixCSSMembre < this.montantFraisAdministration) {
        this.estCoursSansRemboursement = true;
      } else if (this.estScolariseMaison && cours.prixScolarise > 0 && cours.prixScolarise < this.montantFraisAdministration) {
        // Scolarisé à la maison
        this.estCoursSansRemboursement = true;
      } else if (this.estCSSExterne && cours.prixExterne > 0 && cours.prixExterne < this.montantFraisAdministration) {
        // CSS Externe
        this.estCoursSansRemboursement = true;
      } else if (this.estEcolePrive && cours.prixPrive > 0 && cours.prixPrive < this.montantFraisAdministration) {
        // École privé
        this.estCoursSansRemboursement = true;
      }
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    async annulerInscription() {
      this.remboursementPartielEnCours = true;

      // Vérification si est CSSMembre ou Externe
      let montantRemboursementPartiel = 0.00;
      if (this.estCSSMonteregieEstrie) {
        montantRemboursementPartiel = this.cours.prixCSSMembre;
      } else if (this.estScolariseMaison) {
        montantRemboursementPartiel = this.cours.prixScolarise;
      } else if (this.estCSSExterne) {
        montantRemboursementPartiel = this.cours.prixExterne;
      } else if (this.estEcolePrive) {
        montantRemboursementPartiel = this.cours.prixPrive;
      }

      // Remboursement partiel - frais d'administration
      montantRemboursementPartiel -= this.montantFraisAdministration;

      // Si c'est un cours gratuit, remettre le montant à 0 au lieu de la soustraction du frais d'administration
      if (this.estCoursGratuit) {
        montantRemboursementPartiel = 0;
      }

      const remboursement = {
        coursEleveId: this.cours.coursEleveId,
        montantRemboursementPartiel,
        provenanceEleve: this.cours.provenanceEleve,
      };
      await this.paiementStore.effectuerRemboursementPartiel(remboursement).catch((error) => {
        // Affichage du message d'erreur dans le v-alert de PageConfirmation.vue
        this.$emit('echecRemboursement', error);
      }).finally(async () => {
        // Une fois le cours retiré de la liste d'attente, l'enlever du panier. Corrige le bug: 2 cours en attente de paiement -> page de confirmation -> annuler un cours + payer l'autre. Résultat: 2 cours dans le panier quand il en faudrait un seul)
        await this.paiementStore.definirCoursIdSelonCoursEleveId(remboursement.coursEleveId);
        const coursId = this.paiementStore.coursIdPourProcederPaiement;
        this.panierStore.listeCoursPanier = this.panierStore.listeCoursPanier.filter((x) => x.id !== coursId); // Filtre du cours annulé
        const jsonCoursPanier = JSON.stringify(this.panierStore.listeCoursPanier);

        localStorage.setItem(
          racineLocalStorage + localStoragePanier,
          jsonCoursPanier,
        );

        // Loading arrête puisque la requête est finie
        this.remboursementPartielEnCours = false;
      });

      // Tout le reste (incluant le remboursement fonctionnel), est géré dans le watch: getResultatRemboursement dans ConfirmationPaiement.vue
      this.closeDialog();
    },
  },
};
</script>
